
export const Herobanner = (props) => {
    return (
        <div className="slider">
            <div className="sliderimg">
                
            </div>
        </div>
    )
}